import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter, Link } from 'react-router-dom';
import WithEscNavigation from '@hobs/hocs/WithEscNavigation';
import { H1 } from '@hobs/components/Headings';
import { createLoadingSelector } from '@hobs/utils/loading';
import Status from '@hobs/components/Status';
import Icon from '@hobs/components/Icon';
import ShortId from 'shortid';
import { queryOData, resetOData } from '@hobs/actions/odata';
import { SERVICE_REQUEST_NAVIGATION_ORIGIN } from '@hobs/utils/constants';
import { ServiceRequestNavContext } from '@hobs/components/ServiceRequestNavContext';
import { PageLinks } from '../ServiceRequestCustom/PageLinks';
import { getServiceRequest } from '../../actions/serviceRequests';

import ServiceRequestAuditLogs from './ServiceRequestAuditLogs';

import './ServiceRequestCustomAuditLogs.scss';

class ServiceRequestCustomAuditLogs extends React.PureComponent {
  componentDidMount() {
    const { match, getServiceRequest } = this.props;
    getServiceRequest(match.params.serviceRequestId);
  }
  z;

  getChangeHistoryPath() {
    const { match } = this.props;
    return `/service-request/${match.params.serviceRequestId}/change-history`;
  }

  getBackNavigationUrl = navContext => {
    if (navContext === SERVICE_REQUEST_NAVIGATION_ORIGIN.Tickets) {
      return '/tickets';
    }
    return '/requested-services';
  };

  navigateBack = navContext => {
    const { history } = this.props;
    history.push(this.getBackNavigationUrl(navContext));
  };

  getDiscussionPath() {
    const { match } = this.props;
    return `${match.url}/discussion`;
  }

  render() {
    const { t, match, serviceRequest, getServiceRequest } = this.props;
    return (
      <>
        <div className="service-request-custom-auditlog--heading">
          <ServiceRequestNavContext.Consumer>
            {nav => (
              <>
                {this.props.withEscNavigationCallback(() =>
                  this.navigateBack(nav.serviceRequestNavigation)
                )}
                <div className="service-request-custom-auditlog--header">
                  <Link
                    to={this.getBackNavigationUrl(nav.serviceRequestNavigation)}
                  >
                    <Icon icon="BackArrow" />
                    <H1>{t('Request history')} - </H1>
                  </Link>

                  <div className="service-request-custom-auditlog--header-unit">
                    {serviceRequest.partyCode}, {serviceRequest.unitName} (
                    {serviceRequest.requestNumber
                      ? serviceRequest.requestNumber
                      : '-'}
                    )
                  </div>
                  <Status
                    name={serviceRequest.statusGridName}
                    type={serviceRequest.statusId}
                  />
                </div>
              </>
            )}
          </ServiceRequestNavContext.Consumer>
          <PageLinks
            key={ShortId.generate()}
            isEdit={true}
            serviceRequestId={match.params.serviceRequestId}
            partyId={match.params.partyId}
            changeHistoryPath={this.getChangeHistoryPath()}
            discussion={{
              status: serviceRequest.discussionStatus,
              initials: t('HN'),
              discussionPath: this.getDiscussionPath(),
              onDiscussionClose: () =>
                getServiceRequest(match.params.serviceRequestId),
              isSeen: serviceRequest.isLastDiscussionSeen
            }}
          />
        </div>
        <ServiceRequestAuditLogs />
      </>
    );
  }
}

ServiceRequestCustomAuditLogs.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  t: PropTypes.func,
  getServiceRequest: PropTypes.func,
  serviceRequest: PropTypes.object,
  withEscNavigationCallback: PropTypes.func
};

const oDataLoading = createLoadingSelector(['OData']);
const mapStateToProps = state => ({
  isLoading: oDataLoading(state),
  oData: state.odata,
  serviceRequest: state.serviceRequests.item
});

const mapDispatchToProps = {
  queryOData,
  resetOData,
  getServiceRequest
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(WithEscNavigation(ServiceRequestCustomAuditLogs)))
);
